import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import type { PermanentContract } from "@/lib/visitor";
import type { ShopGuest, ShopStay } from "@/lib/shopAuth";

export type ShopMe = {
  guest: ShopGuest;
  stay: ShopStay;
  permanent_contract: PermanentContract | null;
};

export function useShopMe() {
  const [me, setMe] = useState<ShopMe | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void api
      .get<ShopMe>("/api/v1/public/shop/me")
      .then((data) => {
        if (!cancelled) setMe(data);
      })
      .catch(() => {
        if (!cancelled) setMe(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return { me, loading };
}
